function isIdentifier(value) {
  return typeof value === "string" && value.length === 20 && /^([a-z0-9]+)$/.test(value);
}
export {
  isIdentifier
};
